// extracted by mini-css-extract-plugin
export default {"layer-group-header":"style_layer-group-header__kVGHy","layer-group-header-text":"style_layer-group-header-text__xG+7Y"};